// extracted by mini-css-extract-plugin
module.exports = {"bg":"modal_bg__1XHgm","new":"modal_new__27ID3"};